import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { canEdit, getUserType } from "../permissions";
import API_BASE from "../config";

const Customers = () => {
    const navigate = useNavigate();
    const userType = getUserType();
    const allowEdit = canEdit(userType, "customers");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [search, setSearch] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [page, setPage] = useState(1);
    const perPage = 10;

    useEffect(() => {
        setLoading(true);
        fetch(`${API_BASE}/api/allrows`, {
            method: "POST",
            headers: { Authorization: "1", "Content-Type": "application/json" },
            body: JSON.stringify({ token: "3232", table: "customers" }),
        })
            .then((r) => r.json())
            .then((json) => {
                setLoading(false);
                if (Array.isArray(json.data)) setData(json.data);
                else setError("Failed to load customers.");
            })
            .catch(() => { setLoading(false); setError("Error fetching customers."); });
    }, []);

    const cities = [...new Set(data.map((c) => c.city).filter(Boolean))].sort();

    let filtered = data.filter((i) =>
        Object.values(i).join(" ").toLowerCase().includes(search.toLowerCase())
    );
    if (cityFilter) filtered = filtered.filter((i) => i.city === cityFilter);

    const totalPages = Math.ceil(filtered.length / perPage);
    const rows = filtered.slice((page - 1) * perPage, page * perPage);

    return (
        <>
            <style>{`
        .cu-page { display:flex; flex-direction:column; gap:20px; }
        .cu-header { display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
        .cu-title { font-size:22px; font-weight:700; color:#0f172a; }
        .cu-count { font-size:13px; color:#64748b; margin-top:2px; }
        .cu-filters { background:#fff; padding:16px; border-radius:14px; border:1px solid #e2e8f0; box-shadow:0 1px 3px rgba(0,0,0,.04); display:flex; gap:12px; flex-wrap:wrap; align-items:center; }
        .cu-filters input,.cu-filters select { padding:10px 14px; border-radius:10px; border:1px solid #e2e8f0; outline:none; min-width:150px; font-size:13px; font-family:'Inter',sans-serif; color:#334155; background:#f8fafc; transition:all .2s; }
        .cu-filters input { flex:1; min-width:200px; }
        .cu-filters input:focus,.cu-filters select:focus { border-color:#93c5fd; box-shadow:0 0 0 3px rgba(59,130,246,.08); background:#fff; }
        .cu-wrap { background:#fff; border-radius:14px; border:1px solid #e2e8f0; box-shadow:0 1px 3px rgba(0,0,0,.04); overflow-x:auto; }
        .cu-table { width:100%; border-collapse:collapse; min-width:800px; }
        .cu-table th,.cu-table td { padding:13px 14px; font-size:13px; text-align:left; border-bottom:1px solid #f1f5f9; }
        .cu-table th { background:#f8fafc; color:#64748b; font-weight:600; font-size:11px; text-transform:uppercase; letter-spacing:.5px; white-space:nowrap; position:sticky; top:0; }
        .cu-table tbody tr { transition:background .15s; }
        .cu-table tbody tr:hover { background:#f8fafc; }
        .cu-table td { color:#334155; font-weight:500; }
        .cu-name-cell { display:flex; flex-direction:column; gap:1px; }
        .cu-name { font-weight:600; color:#0f172a; text-transform:capitalize; }
        .cu-father { font-size:11px; color:#94a3b8; }
        .cu-phone { font-weight:500; color:#334155; }
        .cu-city { display:inline-block; padding:4px 10px; border-radius:20px; font-size:11px; font-weight:600; background:#eff6ff; color:#2563eb; border:1px solid #bfdbfe; text-transform:capitalize; }
        .cu-addr { font-size:12px; color:#64748b; max-width:200px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; text-transform:capitalize; }
        .cu-edit { padding:6px 14px; border:1px solid #e2e8f0; border-radius:8px; background:#f8fafc; color:#2563eb; cursor:pointer; font-size:12px; font-weight:600; font-family:'Inter',sans-serif; transition:all .2s; white-space:nowrap; }
        .cu-edit:hover { background:#eff6ff; border-color:#93c5fd; box-shadow:0 2px 8px rgba(37,99,235,.12); }
        .cu-pag { display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:12px; }
        .cu-pag-info { font-size:13px; color:#64748b; }
        .cu-pag-btns { display:flex; align-items:center; gap:6px; }
        .cu-pag-btns button { padding:8px 14px; border-radius:8px; border:1px solid #e2e8f0; background:#fff; font-size:13px; font-weight:500; color:#334155; cursor:pointer; transition:all .2s; font-family:'Inter',sans-serif; }
        .cu-pag-btns button:hover:not(:disabled) { background:#f1f5f9; }
        .cu-pag-btns button:disabled { opacity:.4; cursor:not-allowed; }
        .cu-pag-btns span { font-size:13px; color:#64748b; padding:0 6px; }
        .cu-load { display:flex; flex-direction:column; align-items:center; padding:60px 20px; gap:14px; }
        .cu-spin { width:36px; height:36px; border:3px solid #e2e8f0; border-top-color:#2563eb; border-radius:50%; animation:cu-sp .7s linear infinite; }
        @keyframes cu-sp { to{transform:rotate(360deg)} }
        .cu-load-t { font-size:14px; color:#64748b; }
        .cu-err { padding:16px; background:#fef2f2; border:1px solid #fecaca; border-radius:12px; color:#dc2626; font-size:14px; text-align:center; }
        .cu-empty { padding:40px 20px; text-align:center; color:#94a3b8; font-size:14px; }
        @media(max-width:640px){
          .cu-filters{flex-direction:column;align-items:stretch;}
          .cu-filters input,.cu-filters select{min-width:100%;}
          .cu-pag{flex-direction:column;align-items:stretch;text-align:center;}
          .cu-pag-btns{justify-content:center;}
        }
      `}</style>

            <div className="cu-page">
                <div className="cu-header">
                    <div>
                        <h2 className="cu-title">👥 Customers</h2>
                        <div className="cu-count">{loading ? "Loading..." : `${filtered.length} total customers`}</div>
                    </div>
                </div>

                <div className="cu-filters">
                    <input placeholder="🔍 Search by name, phone, city..." value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} />
                    <select value={cityFilter} onChange={(e) => { setCityFilter(e.target.value); setPage(1); }}>
                        <option value="">All Cities</option>
                        {cities.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                </div>

                {error && <div className="cu-err">⚠️ {error}</div>}

                {loading ? (
                    <div className="cu-load"><div className="cu-spin" /><div className="cu-load-t">Loading customers...</div></div>
                ) : (
                    <>
                        <div className="cu-wrap">
                            <table className="cu-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Phone</th>
                                        <th>City</th>
                                        <th>Address</th>
                                        <th>Profession</th>
                                        <th>Email</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.length === 0 ? (
                                        <tr><td colSpan="7"><div className="cu-empty">No customers found</div></td></tr>
                                    ) : rows.map((c) => (
                                        <tr key={c.id}>
                                            <td>
                                                <div className="cu-name-cell">
                                                    <span className="cu-name">{c.name}</span>
                                                    {c.father && <span className="cu-father">S/o {c.father}</span>}
                                                </div>
                                            </td>
                                            <td><span className="cu-phone">{c.phone}</span></td>
                                            <td>{c.city ? <span className="cu-city">{c.city}</span> : "—"}</td>
                                            <td><span className="cu-addr" title={c.address}>{c.address || "—"}</span></td>
                                            <td>{c.proffession || "—"}</td>
                                            <td>{c.gmail || "—"}</td>
                                            <td>
                                                {allowEdit && (
                                                    <button className="cu-edit" onClick={() => navigate("/dashboard/customers/edit", { state: { customer: c } })}>
                                                        ✏️ Edit
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {totalPages > 1 && (
                            <div className="cu-pag">
                                <div className="cu-pag-info">Showing {(page - 1) * perPage + 1}–{Math.min(page * perPage, filtered.length)} of {filtered.length}</div>
                                <div className="cu-pag-btns">
                                    <button disabled={page === 1} onClick={() => setPage(1)}>First</button>
                                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
                                    <span>Page {page} of {totalPages}</span>
                                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                                    <button disabled={page === totalPages} onClick={() => setPage(totalPages)}>Last</button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
};

export default Customers;
